import { render } from "./VentureTeams.vue?vue&type=template&id=f4e6200a"
import script from "./VentureTeams.vue?vue&type=script&lang=js"
export * from "./VentureTeams.vue?vue&type=script&lang=js"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__